"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSpecialSentenceWithSentenceWordStatusSchema = exports.SpecialSentenceWithSentenceWordStatusSchema = exports.isSpecialSentenceWithSpecialWordData = exports.SpecialSentenceWithSpecialWordDataSchema = exports.isSpecialSentence = exports.SpecialSentenceSchema = void 0;
const z = __importStar(require("zod"));
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
const common_sentence_types_1 = require("./common_sentence_types");
const sentence_word_types_1 = require("./sentence_word_types");
exports.SpecialSentenceSchema = common_sentence_types_1.BasicSentenceSchema.extend({
    audio_url: z.string(),
    difficulty: z.string().optional(),
    is_special_word_sentence: z.literal(true),
    is_ugc: z.literal(false).optional(),
    sentence_type: z.union([z.literal("fluent_forever"), z.literal("special")]),
    sentence_words: sentence_word_types_1.SentenceWordSchema.array(),
    special_word: z.string().optional(),
    special_word_gender: z.string().optional(),
});
exports.isSpecialSentence = type_validation_helpers_1.getTypeValidationFunction(exports.SpecialSentenceSchema);
exports.SpecialSentenceWithSpecialWordDataSchema = exports.SpecialSentenceSchema.extend({
    sentence_words: sentence_word_types_1.SentenceWordWithSpecialWordDataSchema.array(),
});
exports.isSpecialSentenceWithSpecialWordData = type_validation_helpers_1.getTypeValidationFunction(exports.SpecialSentenceWithSpecialWordDataSchema);
exports.SpecialSentenceWithSentenceWordStatusSchema = exports.SpecialSentenceSchema.extend({
    sentence_words: sentence_word_types_1.SentenceWordWithStatusSchema.array(),
});
exports.isSpecialSentenceWithSentenceWordStatusSchema = type_validation_helpers_1.getTypeValidationFunction(exports.SpecialSentenceWithSentenceWordStatusSchema);
//# sourceMappingURL=special_sentence_types.js.map